import baseApi, { TAGS } from './baseApi';
import { sentryCaptureException } from '../utils/sentryUtils';

/***************************************** API *****************************************/
const idVerificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIdVerification: builder.query({
      query: (userId) => ({
        url: `web-ops/user/${userId}/id-verification`,
        method: 'GET'
      }),
      providesTags: [TAGS.ID_VERIFICATION],
      transformResponse: (response) => response.data
    }),
    resetIdVerification: builder.mutation({
      query: (userId) => ({
        url: `web-ops/user/${userId}/id-verification/reset`,
        method: 'POST'
      }),
      invalidatesTags: [TAGS.ID_VERIFICATION, TAGS.TASK],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
        }
      }
    })
  })
});

/***************************************** HOOKS *****************************************/
export const { useGetIdVerificationQuery, useResetIdVerificationMutation } = idVerificationApi;
